import { useCallback } from 'react';

import Button from 'components/shared/Button/Button';

const AddProviderButton = ({ onOpenAddProvider, isInNetworkTab }) => {
  const handleAddProvidersClick = useCallback(() => {
    onOpenAddProvider?.(isInNetworkTab);
  }, [onOpenAddProvider, isInNetworkTab]);

  return (
    <Button
      variant="link"
      size="small"
      icon="add-circle-mono"
      text={`Add ${isInNetworkTab ? 'in-network' : 'out-of-network'} providers`}
      onClick={handleAddProvidersClick}
    />
  );
};

export default AddProviderButton;
